module.exports = __webpack_public_path__ + "img/smartphone-and-speech-bubble.9501ebd4.svg";